import { rem } from 'polished';
import * as React from 'react';
import styled from 'styled-components';
import { IconType, SvgIcon } from './SvgIcon';

interface Props {
  text: string;
}

export const InfoPanel = ({ text }: Props): JSX.Element => {
  const [isShown, setIsShown] = React.useState(true);

  const hidePanel = (): void => {
    setIsShown(false);
  };

  return (
    <>
      {isShown && text !== '' && (
        <Wrapper>
          <Container>
            <Text>{text}</Text>
            <StyledSvgIcon
              icon={IconType.xSmall}
              width={16}
              height={16}
              viewBox="0 0 16 16"
              cursor="pointer"
              onClick={hidePanel}
            />
          </Container>
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.success};
  padding: ${rem(20)} ${rem(16)};
  z-index: 6;
`;

const Container = styled.div`
  max-width: ${({ theme }) => `${theme.grid.container.wide}px`};
  margin: 0 auto;
  padding: 0 ${rem(24)};
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.mediab.l925`
    padding: 0;
  `};
`;

const Text = styled.p`
  font-size: ${rem(14)};
  line-height: ${rem(17)};
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  font-weight: 500;
  margin: 0;
  font-family: ${({ theme }) => theme.font.primary};
  flex: 1 1 auto;
`;

const StyledSvgIcon = styled(SvgIcon)`
  fill: ${({ theme }) => theme.colors.white};
  flex: 0 0 auto;
  margin-left: ${rem(12)};
`;
